import { fromJS } from 'immutable';
import type { AnyAction } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import { INIT, INIT_SUCCESS, INIT_FAILED, LOAD_FORM } from './types';

export type CampaignPageState = TypedMap<{
  loading: boolean;
  error: boolean;
}>;

export const initialState = fromJS({
  loading: false,
  error: false,
}) as CampaignPageState;

export default (state: CampaignPageState = initialState, action: AnyAction): CampaignPageState => {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    case LOAD_FORM:
      return { data: action.data };

    default:
      return state;
  }
};
